import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          An commit Edit in <code>src/App.js</code> 
        </p>
        <a>
          Welcome to a sample react app deployed on cloudflare
        </a>
      </header>
    </div>
  );
}

export default App;
